let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wU8O")).then(() => parcelRequire('7Xg82'));